import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import i18n from 'i18n';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';

const LogoGroup = ({ className }) => (
  <div className={className}>
    <p>{i18n.t('common:footer.description')}</p>
    <p>{i18n.t('common:footer.copyright')}</p>
  </div>
);

const commonStyle = css`
  p {
    text-align: center;
    font-size: 0.7rem;
    color: ${Colors.gray1};
    margin: 0 0 12px;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
`;

const spStyle = CustomMedia.lessThan('medium')`
  padding-bottom: 8px;
  p {
    ${FontStyles.text12};
    margin: 0 0 4px;

    &:last-child {
      margin: 0;
    }
  }
`;

export default applyStyles(LogoGroup)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/Footer/components/LogoGroup.js